import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'groupStats',
  pure: true,
})
export class GroupStatsPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values: {
      [outerGroup: string]: {
        [innerGroup: string]: number,
      },
    } | undefined,
  ): {
    group: string;
    count: number;
    sum: number;
    min: number;
    max: number;
    avg: number;
  }[] {
    return this.statisticsExtractor.aggregateNumericStatsByGroup(values);
  }

}
